import React, { useEffect } from 'react';
import EventEmitter from 'wolfy87-eventemitter';
import context from '../../context';
import MapUI from './MapUI';
import MapStateProxy from './MapStateProxy';
class MapManager extends EventEmitter{
    stateProxy = null;
    map = null;
    _mapUI = null;
    constructor(state){
        super();
        this.state = state;
        this.stateProxy = new MapStateProxy(context.appConfig.map);
    }

    getMapUIRender() {
        return <MapUI ref={ref => {
            if (!ref) return;
            this._mapUI = ref;
            this.map = ref.map
        }} stateProxy={this.stateProxy} />
    }
}
export default MapManager;